import {useOrderStore} from '~/stores/order';

const useSegregatedPayer = () => {
  const orderStore = useOrderStore()

  const services = computed(() => {
    return Object.entries(orderStore.orderForm.customer.segregated.list).map(([key, value]) => {
      const p = orderStore.orderForm.services?.find(s => s.guid === key)
      if (p) {
        p.payer = (orderStore.orderForm.customer.segregated.list[key] as string)
      }
      return p
    })
  })

  const currencyMeasure = computed(() => {
    return orderStore.orderPriceCurrency.currency
  })

  function payerPrice(payer: string): number {
    const { list } = orderStore.orderForm.customer.segregated
    const guids = Object.keys(orderStore.orderForm.customer.segregated.list)
    let price = 0
    guids.forEach((guid) => {
      const service = orderStore.orderForm.services?.find(s => s.guid === guid && list[guid] === payer)
      if (service) {
        price += service.cost
      }
    })

    return price
  }

  async function onChangeSegregatedPayer(item: any): Promise<void> {
    const service = orderStore.orderForm.services?.find( s => s.dependence.includes(item.guid))
    if ( service ) {
      orderStore.orderForm.customer.segregated.list[service.guid] = item.value
    }
    orderStore.orderForm.customer.segregated.list[item.guid] = item.value
    Object.keys(orderStore.orderForm.customer.segregated.list).forEach( (k: string) => {
      const p = orderStore.orderForm.services?.find(s => s.guid === k)
      if (p) {
        p.payer = (orderStore.orderForm.customer.segregated.list[k] as string)
      }
    })
  }

  return {
    services,
    currencyMeasure,
    payerPrice,
    onChangeSegregatedPayer
  }
}

export default useSegregatedPayer